'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Icon = require('../../Icon/src/Icon.js');
var Rate_module = require('../styles/Rate.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const Star = (props) => {
    const { className, index, value, size, fractional, disabled, onClick, onHover } = props;
    const thirdFilled = value && value > index;
    const halfFilled = value && value > index + 0.3;
    const threeQuartersFilled = value && value > index + 0.5;
    const fullFilled = value && value > index + 0.8;
    const focusedSecond = value && value >= index + 1;
    const cx = reactUtils.useStyles(Rate_module.default);
    const classNames = cx(className, 'star-container', {
        disabled,
    });
    const starClassNames = cx('star', {
        disabled,
        [`size-${size}`]: size,
        fill: focusedSecond,
    });
    const halfStarClassNames = cx('star', 'half', {
        disabled,
        [`half-${size}`]: size,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'third-filled': thirdFilled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'half-filled': halfFilled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'three-quarters-filled': threeQuartersFilled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'full-filled': fullFilled,
        fill: thirdFilled || halfFilled || threeQuartersFilled || fullFilled,
    });
    const handleClick = React__namespace.useCallback((event) => {
        onClick?.(event, index);
    }, [index, onClick]);
    const handleHover = React__namespace.useCallback((event) => {
        onHover?.(event, index);
    }, [index, onHover]);
    return (React__namespace.createElement("div", { className: classNames, onClick: disabled ? reactUtils.noop : handleClick, onMouseMove: disabled ? reactUtils.noop : handleHover },
        fractional ? React__namespace.createElement(Icon.Icon, { className: halfStarClassNames, icon: React__namespace.createElement(reactIcons.Star, null) }) : null,
        React__namespace.createElement(Icon.Icon, { className: starClassNames, icon: React__namespace.createElement(reactIcons.Star, null) })));
};
Star.displayName = 'Star';

exports.Star = Star;
//# sourceMappingURL=Star.js.map
